import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  isFetching: false,
  industries: [],
  industryRolesIsFetching: false,
  industryRoles: [],
  cpdCategorysIsFetching: false,
  cpdCategorys: [],
  industriesWithCpdCategorys: [],
  error: undefined
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('industries')(configurations),
  [LOCATION_CHANGE]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      error: undefined
    });
  }
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/industry/reducers.js